import React from 'react'
import ReactDOM from 'react-dom'
import TournamentApp from '../pages_index/tournament_app'
import consumer from '../channels/consumer'
import axios from 'axios'

function spaPageHit (pageTitle, pagePath) {
  if (!window.dataLayer) { return }

  window.dataLayer.push({
    event: 'pageview',
    page: {
      path: `${window.location.pathname}${pagePath}`,
      title: pageTitle
    }
  })
}

const csrfToken = document.querySelector('meta[name=csrf-token]').content

axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

let state = {}

function join (uuid, captchaResponse) {
  renderApp({ loading: true })

  axios.post(`/sng_tournaments/${uuid}/check_in.json`, { captcha: captchaResponse })
    .then(function (response) {
      spaPageHit('Poker Now - Join Discord Sit & Go', '/join_discord_sit_and_go')

      renderApp({ ...response.data.new_state, loading: false })

      window.alert(response.data.message)
    })
    .catch(function (error) {
      renderApp({ loading: false })

      let response = error.response

      if (response.status === 401) {
        window.location = `/sessions/new?back_to=${window.location.href}`
        return
      }

      if (response.status === 422) {
        window.alert(response.data.message)

        if (response.data.error_id === 'missing_username') {
          window.location = `/current_user/edit?back_to=${window.location.href}`
        }
      } else {
        window.alert('Something wrong happened. We were already notified about this, don\'t worry.')
      }
    })
}

function cancel (uuid) {
  renderApp({ loading: true })

  axios.post(`/sng_tournaments/${uuid}/checkout.json`)
    .then(function (response) {
      spaPageHit('Poker Now - Join Discord Sit & Go', '/checkout_discord_sit_and_go')

      renderApp({ ...response.data.new_state, loading: false })

      window.alert(response.data.message)
    })
    .catch(function (error) {
      renderApp({ loading: false })

      if (response.status === 401) {
        window.location = '/auth/discord'
        return
      }

      let response = error.response

      if (response.status === 422) {
        window.alert(response.data.message)
      } else {
        window.alert('Something wrong happened. We were already notified about this, don\'t worry.')
      }
    })
}

function renderApp (data) {
  state = { ...state, ...data }

  ReactDOM.render(
    <TournamentApp
      join={(captchaResponse) => join(state.uuid, captchaResponse)}
      cancel={() => cancel(state.uuid)}
      data={state} />,
    document.getElementById('main-sng-tournament-app-container'),
  )
}

let blurredAt
let connected

let sngTournamentChannel = consumer.subscriptions.create({ channel: 'SngTournamentStatusChannel' }, {
  received (data) {
    connected = true
    renderApp({ ...data, connected: true })
  },

  disconnected () {
    connected = false
    renderApp({ connected: false })
  }
})

window.addEventListener('blur', () => {
  blurredAt = (new Date()).getTime()
})

window.addEventListener('focus', () => {
  blurredAt = null
})

const minutesToDisconnect = 60

setInterval(() => {
  let now = (new Date()).getTime()

  if (blurredAt && ((blurredAt + (minutesToDisconnect * 60 * 1000)) < now)) {
    consumer.disconnect()
  }

  if (connected) {
    sngTournamentChannel.send({ type: 'pong' })
  }
}, 30 * 1000)

document.addEventListener('DOMContentLoaded', () => {
  renderApp({})
})
